module.exports = __webpack_public_path__ + "static/media/login_cover.fc0ce97d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_cover.jpg
// module id = 2451
// module chunks = 0